import * as React from 'react';

import createLoadableComponent from 'js/lib/createLoadableComponent';
import { isCourserian } from 'js/lib/user';

const LoadableCoachStudio = createLoadableComponent(() => import('bundles/ai-coach-studio'));

export const showCoachStudio = () => {
  return isCourserian();
};

const CoachStudioGridItem = () => {
  return <LoadableCoachStudio />;
};

export default CoachStudioGridItem;
